//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        value: true,
        disable: Boolean,
        disabledDates: [Date, Object, Array],
        pageDate: Date,
        maxRangeLength: Number,
    },

    data() {
        return {
            fromPage: this.toMonthYear((this.value && (this.value instanceof Date ? this.value : this.value.start)) || this.pageDate || new Date()),
            firstClickDate: null,
        };
    },

    computed: {
        mode() {
            return (!this.value || this.value instanceof Date) ? 'single' : 'range';
        },
        attributes() {
            return [{ key: 'today', highlight: 'green', dates: new Date() }];
        },
        disabledDates_() {
            if (!this.maxRangeLength || !this.firstClickDate)
                return this.disabledDates;

            // If max range length is specified and 1st date has been selected, restrict 2nd date
            return [
                { end: dayjs(this.firstClickDate).subtract(this.maxRangeLength, 'days').toDate() },
                { start: dayjs(this.firstClickDate).add(this.maxRangeLength, 'days').toDate() },
                ...(this.disabledDates || []),
            ];
        },
        todayVisible() {
            const today = new Date();

            return this.fromPage.month === today.getMonth() + 1 && this.fromPage.year === today.getFullYear();
        },
    },

    methods: {
        onClick(ev) {
            if (this.disable) {
                ev.preventDefault();
                ev.stopPropagation();
            }
        },
        onDayClick(day) {
            this.firstClickDate = day.date;

            this.$emit('dayclick', day);
        },
        goToToday() {
            this.$refs.picker.$refs.calendar.showPageRange(new Date());
        },
        toMonthYear(date) {
            return { month: date.getMonth() + 1, year: date.getFullYear() };
        },
    },
};
